import 'jquery';
import { PNotify } from '@sop/unify-pnotify';
import { Foldout } from './foldout.js';

// taken from example on pnotify..
export var stack_bar_top = {
    addpos2: 0,
    animation: true,
    dir1: "down",
    dir2: "right",
    firstpos1: 0,
    firstpos2: 0,
    nextpos1: 0,
    nextpos2: 0,
    push: "top",
    spacing1: 0,
    spacing2: 0
};

export function showNotification(o) {
    alert(o);
}

/**
* alert is the function that shows a alert on the page.
* It will initially use the plugin pNotify but it could change over time.
* @param {eventobject} o Is the message object
*/
export function alert(o) {
    // create a object of the optional parameters if it is not sent to the user
    o = o === undefined ? {} : o;

    // set all parameters to the object, if not sent with the option possible default value is set.
    o.message = (typeof o.message === 'undefined') ? '' : o.message;
    o.title = (typeof o.title === 'undefined') ? undefined : o.title;
    o.type = (typeof o.type === 'undefined') ? 'info' : o.type; // possible values are the bootstrap danger, info, success,  warning 

    // not mandatory (add below)
    o.plugin = (typeof o.plugin === 'undefined') ? 'pnotify' : o.plugin;

    if (o.plugin === 'pnotify') {
        // 1. Message will be shown with jQuery plugin that is called Pines Notify (http://pinesframework.org/pnotify/)

        /* 
        * A Pines Notify have many different parameters, look at function addJqueryPnotifyNotification for several of possible
        * parameters and the default values used.
        * All parameters sent to this function will be sent to that function as well but if you want to make your messages to have different default values
        * override function addJqueryPnotifyNotificationOverride.
        * The type of messages used in the framework are at writing moment those supported in Bootstrap 4 which is:
        * bootstrap -- danger, info, success, warning
        * and in pNotify's are 
        * pnotify   -- "notice", "info", "success", or "error".* 
        * so we translate t´he types below.
        */
        //o.width = o.width == null ? undefined : o.width; // make null to undefined because pnotify will accept null ass a value that changes the default value (300px)
        o.width = undefined;// let the width be not changable..

        // bootstrap -- danger, info, success, warning
        // pnotify   -- "notice", "info", "success", or "error".
        // bootstrap 4 colors:Primary, secondary, success, info, warning, danger, link
        switch (o.type) {
            case 'danger': o.type = 'error'; break;
            case 'info': o.type = 'info'; break;
            case 'success': o.type = 'success'; break;
            case 'warning': o.type = 'error'; break;
            default: o.type = 'notice'; break; // white, not used from messages from serverside.. change it?
        }

        // move message parameter to text parameter (can not use o.text = o.message; delete o.message; which would destroy both values..)
        var text = o.message;
        o.text = text;
        delete o.message;

        // if title is sent but is empty, remove it to avoid strange looking pNotify layout (empty space above message)
        if (o.title === '') {
            delete o.title;
        }

        o.addclass = "stack-bar-top";
        o.cornerclass = "";
        o.width = "100%";
        o.stack = stack_bar_top;

        // OBSERVER! by adding the namespace here in conjuction of having it exported will make it possible to override it
        // if Unify is left out the function inside the closure will not be possible to override
        alertPnotifyOverride(o);
        return;
    }
}

/**
* alertpNotifyOverride is a helper function that you easily could overide and capture all calls on the page from the framework with.
* I.e override it and you know all function calls will use your own settings.
* @function
* @param {object} o options to pnotify
*/
export function alertPnotifyOverride(o) {
    addPnotifyNotification(o);
}

/**
* addPnotifyNotification adds a notification to the page using the http://pinesframework.org/pnotify/ plugin. Available options are easaly tested/shown on the page and
* if you add them to the parameter o it will be passed to the notification. The default values 
* @function
* @param {object} o is the optional parameters, when you want to add a parameter you add the parameter name to the object with the value (possible options are on the pines notify page http://pinesframework.org/pnotify/ , the ones existing when inserted are shown below in function)
* @examples 
*   addJqueryPnotifyNotification({text:'text'});                     // a notification with the text text
*   addJqueryPnotifyNotification({text:'text',styling: 'jqueryui'}); // a notification with the text text and styling of jqueryui
*/
export function addPnotifyNotification(o) {
    // default values can be found using $.pnotify.defaults, or look below for the overrides
    // pnotify name                                                               default value
    //PNotify.prototype.options.styling = "fontawesome";

    o = o === undefined ? {} : o;
    //o.addclass               = (typeof o.addclass               === 'undefined') ? 'spPnotify'   : o.addclass;               // Additional classes to be added to the notice. (For custom styling.)
    //o.animation              = (typeof o.animation              === 'undefined') ? undefined     : o.animation;              // The animation to use when displaying and hiding the notice. "none", "show", "fade", and "slide" are built in to jQuery. Others require jQuery UI. Use an object with effect_in and effect_out to use different effects.
    //o.animate_speed          = (typeof o.animate_speed          === 'undefined') ? undefined     : o.animate_speed;          // Speed at which the notice animates in and out. "slow", "def" or "normal", "fast" or number of milliseconds.
    //o.auto_display           = (typeof o.auto_display           === 'undefined') ? undefined     : o.auto_display;           // Display the notice when it is created. Turn this off to add notifications to the history without displaying them.
    //o.closer                 = (typeof o.closer                 === 'undefined') ? undefined     : o.closer;                 // Provide a button for the user to manually close the notice.
    //o.closer_hover           = (typeof o.closer_hover           === 'undefined') ? undefined     : o.closer_hover;           // Only show the closer button on hover.
    //o.cornerclass            = (typeof o.cornerclass            === 'undefined') ? undefined     : o.cornerclass;            // Class to be added to the notice for corner styling.
    //o.delay                  = (typeof o.delay                  === 'undefined') ? undefined     : o.delay;                  // Reset the hide timer if the mouse moves over the notice.
    //o.hide                   = (typeof o.hide                   === 'undefined') ? undefined     : o.hide;                   // After a delay, remove the notice.
    //o.history                = (typeof o.history                === 'undefined') ? false         : o.history;                // Display a pull down menu to redisplay previous notices, and place the notice in the history.
    //o.icon                   = (typeof o.icon                   === 'undefined') ? false         : o.icon;                   // Set icon to true to use the default icon for the selected style/type, false for no icon, or a string for your own icon class.
    //o.insert_brs             = (typeof o.insert_brs             === 'undefined') ? undefined     : o.insert_brs;             // Change new lines to br tags.
    //o.labels                 = (typeof o.labels                 === 'undefined') ? undefined     : o.labels;                 // {redisplay: "Redisplay", all: "All", last: "Last", close: "Close", stick: "Stick"} - Lets 
    //o.maxonscreen            = (typeof o.maxonscreen            === 'undefined') ? undefined     : o.maxonscreen;            // Maximum number of notifications to have onscreen.
    //o.min_height             = (typeof o.min_height             === 'undefined') ? undefined     : o.min_height;             // Minimum height of the notice. It will expand to fit content.
    //o.mouse_reset            = (typeof o.mouse_reset            === 'undefined') ? undefined     : o.mouse_reset;            // Remove the notice's elements from the DOM after it is removed.
    //o.nonblock               = (typeof o.nonblock               === 'undefined') ? undefined     : o.nonblock;               // Create a non-blocking notice. It lets the user click elements underneath it.
    //o.nonblock_opacity       = (typeof o.nonblock_opacity       === 'undefined') ? undefined     : o.nonblock_opacity;       // The opacity of the notice (if it's non-blocking) when the mouse is over it.
    //o.opacity                = (typeof o.opacity                === 'undefined') ? undefined     : o.opacity;                // Opacity of the notice.
    //o.position_animate_speed = (typeof o.position_animate_speed === 'undefined') ? undefined     : o.position_animate_speed; // Specify a specific duration of position animation.
    //o.remove                 = (typeof o.remove                 === 'undefined') ? undefined     : o.remove;                 // Change new lines to br tags.
    //o.shadow                 = (typeof o.shadow                 === 'undefined') ? true          : o.shadow;                 // Display a drop shadow.
    //o.stack                  = (typeof o.stack                  === 'undefined') ? undefined     : o.stack;                  // {"dir1": "down", "dir2": "left", "push": "bottom", "spacing1": 25, "spacing2": 25} - The stack on which the notices will be placed. Also controls the direction the notices stack.
    //o.sticker                = (typeof o.sticker                === 'undefined') ? undefined     : o.sticker;                // Provide a button for the user to manually stick the notice.
    //o.sticker_hover          = (typeof o.sticker_hover          === 'undefined') ? undefined     : o.sticker_hover;          // Only show the sticker button on hover.
    //o.styling                = (typeof o.styling                === 'undefined') ? 'fontawesome' : o.styling;                // What styling classes to use. (Can be either jqueryui, bootstrap, bootstrap3, fontawesome, or a custom style object. See the source for the properties in a style object.)
    //o.text                   = (typeof o.text                   === 'undefined') ? undefined     : o.text;                   // The notice's text.
    //o.text_escape            = (typeof o.text_escape            === 'undefined') ? undefined     : o.text_escape;            // Whether to escape the content of the text. (Not allow HTML.)
    //o.title                  = (typeof o.title                  === 'undefined') ? undefined     : o.title;                  // The notice's title.
    //o.title_escape           = (typeof o.title_escape           === 'undefined') ? undefined     : o.title_escape;           // Whether to escape the content of the title. (Not allow HTML.)
    //o.type                   = (typeof o.type                   === 'undefined') ? undefined     : o.type;                   // Type of the notice. "notice", "info", "success", or "error".
    //o.width                  = (typeof o.width                  === 'undefined') ? undefined     : o.width;                  // Width of the notice.

    new PNotify(o);
}

/**
* stopBubbling is a function that stops the event to bubble. It could be used anywhere.
* It is used in the span which has popover function to hinder the event from sending click to enclosing title
* ( $('.dashboard-title').on('click.unify', Sp.dashboardClick); ) which will hide the dashbord when the title is clicked
* @param {object} e Is the event
* @returns {bool} false
*/
export function stopBubbling(e) {
    e.stopPropagation();
    e.preventDefault();
    return false;
}

/*
* guid creates random guid
*/
export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

/**
* kept for backwards compatibility. Use foldout.toggle() instead.
* @param {object} foldoutTitleObject foldout title object
*/
export function foldoutClick(foldoutTitleObject) {
    var foldout = new Foldout();
    foldout.toggle($(foldoutTitleObject).closest('.' + Foldout.CLASS));
}

/**
* closePopoverIfClickingOnBody is a function that closes all popover's on the page when you click anywhere on the page body.
* popover is a bootstrap optional plugin used when showing optional content on the page: http://getbootstrap.com/javascript/#popovers
*/
export function closePopoverIfClickingOnBody() {
    $('body').on('click', function (e) {
        $('[data-toggle="popover"]').each(function () {
            //the 'is' for buttons that trigger popups
            //the 'has' for icons within a button that triggers a popup
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });
}

/**
* Returns a random number between min (inclusive) and max (exclusive)
* @param {number} min min number
* @param {number} max max number
* @returns {number} float between min and max
*/
export function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}

/**
* Returns a random integer between min (inclusive) and max (inclusive)
* Using Math.round() will give you a non-uniform distribution!
* @param {number} min min number
* @param {number} max max number
* @returns {number} int between min and max
*/
export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
* sortObjectsByProperties sorts a object recursivly given which object properties to sort on
* @param {object} o object
* @param {object} o.objectToSort is the object that should be sorted (must be of type object..)
* @param {string} o.itemsName is the name of the property that holds other objects to sort on, defaults to items
* @param {Array<string>} o.sortByPropertyArray is an array of property names that should be sorted opon, usually a SortId or Name. When passed with array it will sort on all values.
* @example
*   sort 3 objects by the property 'Name'
*       sortObjectsByProperties( { objectToSort : { items: [{Name:'Bcd'}, {Name:'Abc'}, {Name:'Cde'}]}, sortByPropertyArray: ['Name'] } );
*          returns { items: [ {Name:'Abc'}, {Name:'Bcd'}, {Name:'Cde'} ] }
*
*   sort 3 objects by the property 'SortId', then by property 'Name' 
*       sortObjectsByProperties( { objectToSort : { items: [{SortId:2, Name:'Aaa' } ,{SortId:1, Name:'Bcd' },{SortId:1, Name:'Acd'}] },
*                                  sortByPropertyArray: ['SortId','Name'],
*                                  });
*       should return { items: [ {SortId:1, Name:'Acd'}, {SortId:1, Name:'Bcd'}, {SortId:2, Name:'Aaa'}] }
*
*    sort object structure 
*         sortObjectsByProperties( { objectToSort : { items: [{SortId:2, Name:'Aaa', items: [{SortId:2, Name:'AAA' } ,{SortId:1, Name:'BBB' }]} ,{SortId:1, Name:'Bcd' },{SortId:1, Name:'Acd'}] }, sortByPropertyArray: ['SortId','Name'] });
* 
* 
* @returns { [SORTEDOBJECTS] | {ITEMSNAME: [SORTEDOBJECTS]} } object
*/
export function sortObjectsByProperties(o) {
    o = typeof o === 'undefined' ? {} : o;
    o.objectToSort = typeof o.objectToSort === 'undefined' ? '' : o.objectToSort; // the object that should be sorted
    var itemsName = typeof o.itemsName === 'undefined' ? 'Items' : o.itemsName; // if items in object does not have name items (default)
    o.sortByPropertyArray = typeof o.sortByPropertyArray === 'undefined' ? '' : o.sortByPropertyArray;

    // check for not valid data
    if (o.objectToSort === '') {
        console.log('function sortObjectsByProperties was called to sort on none existing objectToSort, please set variable objectToSort with the function');
    }

    // if a leaf(no items), return the object itself
    if (typeof o.objectToSort[itemsName] === 'undefined') {
        return o.objectToSort;
    }
    for (var i = 0, nr = o.objectToSort[itemsName].length; i < nr; i++) {
        var item = o.objectToSort[itemsName][i];
        item = sortObjectsByProperties({
            objectToSort: item,
            sortByPropertyArray: o.sortByPropertyArray,
            itemsName: itemsName
        });
    }

    // sort the array
    o.objectToSort[itemsName] = o.objectToSort[itemsName].sort(sortByProperties(o.sortByPropertyArray));
    return o.objectToSort;
}

/* 
* Sorts by property from given array
* @Example yourArray.sort(sortByProperties(['SortId', 'Name']))
*/
function sortByProperties(propArray) {
    return function (a, b) {
        for (var i = 0, nr = propArray.length; i < nr; i++) {
            // test the first property in the array
            var prop = propArray[i];

            // if both objects have the property do normal property compare
            if (typeof a[prop] !== 'undefined' && typeof b[prop] !== 'undefined') {
                if (a[prop] > b[prop]) {

                    return 1;
                } else if (a[prop] < b[prop]) {
                    return -1;
                }
                // if equal, compare next sort property if it exist
                //return 0;
            }

            // if only prop value exist in one of the object sort on that to
            else if (typeof a[prop] !== 'undefined') {
                return -1;
            }
            else if (typeof b[prop] !== 'undefined') {
                return 1;
            }

            // else non of the objects had the first property, try the next one in the propertyArray
        }

        // none of the properties worked to compare the objects, return 0 which say they are equal
        return 0;
    }
}


/**
* renameProperties is a helper function that renames properties of given objects with given new names.
* @function
* @param {object} o is optional parameters
*                 Available values:
*                 objects             - array of objects that should be renamed
*                 propertyChangeArray - array of [NAMECHANGEPROPERTY] that should be changed, a NAMECHANGEPROPERTY == { oldName: 'OLDNAME', newName: 'NEWNAME' }
* @returns {object} renamed object
* @example
*  renameProperties({ objects: [{ date: '2014-05-11', weight: 83.6 }], propertyChangeArray: [{ oldName: 'weight', newName: 'aWeight' }] });
*/
export function renameProperties(o) {
    o = typeof o === 'undefined' ? {} : o;
    o.objects = typeof o.objects === 'undefined' ? '' : o.objects;
    o.propertyChangeArray = typeof o.propertyChangeArray === 'undefined' ? '' : o.propertyChangeArray;

    if (o.propertyChangeArray === '') {
        console.log('renameProperties called without parameter propertyChangeArray set, will return nothing');
    }

    for (var i = 0, nr = o.objects.length; i < nr; i++) {
        var object = o.objects[i];
        // rename each property in the object that is mentioned in the propertyChangeArray
        for (var p = 0, pNr = o.propertyChangeArray.length; p < pNr; p++) {
            var property = o.propertyChangeArray[p];
            /*
            * Each object property in propertyChangeArray should have to fields:
            * oldName, newName
            */
            if (object.hasOwnProperty(property.oldName) && !object.hasOwnProperty(property.newName)) {
                object[property.newName] = object[property.oldName];
                delete object[property.oldName];
            }
        }
    }
    return o.objects;
}

/**
* getUniqueComponentId creates ids to be used on the page.
* It will check if the id is used on the page with jQuery so it need to 
* be called after the page has been rendered to ensure the id to be unique.
* @param {object} o object
* @return {string} id
* @example
*       get a unique id
*           getUniqueComponentId()
*           returns ["SOMENUMBER"]
*       get a unique id wit prefix test
*           getUniqueComponentId({prefix:'test'})
*           return ["testSOMENUMBER"]
*/
export function getUniqueComponentId(o) {
    // if o is not set, create one
    o = typeof o === 'undefined' ? {} : o;
    o.prefix = typeof o.prefix === 'undefined' ? '' : o.prefix;
    o.notValidIds = typeof o.notValidIds === 'undefined' ? [] : o.notValidIds;
    o.nrIds = typeof o.nrIds === 'undefined' ? 1 : o.nrIds;
    o.maxNrTriesBeforeExit = typeof o.maxNrTriesBeforeExit === 'undefined' ? 10000 : o.maxNrTriesBeforeExit;
    o.createdIds = typeof o.createdIds === 'undefined' ? [] : o.createdIds;
    o.maxUniqueNrTested = typeof o.maxUniqueNrTested === 'undefined' ? 100000 : o.maxUniqueNrTested;

    var variableExist;
    var id = '';
    var maxNrTriesBeforeExit = o.maxNrTriesBeforeExit;
    var counter = 0;
    do {
        variableExist = false;
        // create random nr (should I incremet instead?, if increment easier on the eyes.. )
        var nr = getRandomInt(1, o.maxUniqueNrTested);
        // var nr = counter + 1;
        id = o.prefix + nr;
        // does it exist in not allowed Ids?
        if ($.inArray(id, o.notValidIds) !== -1) {
            // exist in not valid ids array
            variableExist = true;
            counter++;
            continue;
        }
        // does it exist in dom?
        if ($('#' + id).length !== 0) {
            // do exist in dom
            variableExist = true;
            counter++;
            continue;
        }
        // add the number to the created array
        o.createdIds.push(id);
        // add to the not valid array if you want several ids
        o.notValidIds.push(id);

        // check if nr items was created
        if (o.createdIds.length >= o.nrIds) {
            // all neeaded number was created
            break;
        }
    } while (counter < maxNrTriesBeforeExit)

    // check if nr created numbers was correct
    if (o.nrIds !== o.createdIds.length) {
        // not all number was created
        console.log('getUniqueComponentId: not all numbers was created in function getUniqueComponentId', o);
        return undefined;
    }
    return o.createdIds;
}

/**
* traverseDepthFirst traverse a json object and calls given function with its node
* @param {object} o object
* @param {object} func function
* @returns {Array<object>} array of the things the function returns
* @example
*           get all objects with attribute IsActive = true
*           var JSON = { "IsActive": true }
*           filterHasIsActiveAttribute(object:any){
*                        if (typeof object !== 'undefined' && typeof object.IsActive !== 'undefined') {
*                    return object;
*                }
*            }
*           traverseDepthFirst(JSON)
*/
export function traverseDepthFirst(o, func) {
    var returns = [];
    /* 
    * difference apply vs call
    * theFunction.apply(valueForThis, arrayOfArgs)
    * theFunction.call(valueForThis, arg1, arg2, ...)
    */

    // execute function (this is used to reference the function parameter, it is not a
    // possible strict violation. So we disable the jshint warning)
    /*jshint validthis: true */
    var returned = func.call(this, o);
    if (typeof returned !== 'undefined') {
        returns.push(returned);
    }
    // call every object of given o (I.e. recursivly)
    for (var i in o) {
        if (o[i] !== null && typeof (o[i]) === 'object') {
            //going on step down in the object tree!!
            var array = traverseDepthFirst(o[i], func);
            if (typeof array !== 'undefined') {
                returns = returns.concat(array);
            }
        }
    }
    return returns.length > 0 ? returns : undefined;
}

/**
* OBS! If you only want to highlight text, use window.unify.highlightText
* highlight rewrites given search string with <b></b> tags (or what is specified in parameter highlight) around matches found in the string which is the same as the data
* @function 
* @param {object} o object
* @param {string} o.highlightThis highlightThis is the substring that should be highlighted
* @param {string} o.string is the string that should be highlighted
* @paramter highlight highlight is a optional string describing how the value should be higlighted with. 
             Default == <b>$1</b>, where $1 is the match (must be in the string parameter). 
* @returns {string} string which is highlighted
*/
export function highlight(o) {
    o.highlightThis = typeof o.highlightThis === 'undefined' ? '' : o.highlightThis;
    o.string = typeof o.string === 'undefined' ? '' : o.string;
    o.highlight = typeof o.highlight === 'undefined' ? '<b>$1</b>' : o.highlight;

    return o.string.replace(new RegExp("(" + preg_quote(o.highlightThis, '') + ")", 'gi'), o.highlight);
}

/**
* OBS! Use this function, it only works with highlight with <b>TEXT</b>... which is default..
* highlightText highlights the given string with <b>TEXT</b> tags (or what is given as the highlight).
* What will be highlighted are the words in the given parameter highlightThis, what should be highlighted is in given parameter string 
* and how it should be highlighted is customizable with parameter highlight.
* @function 
* @paramter {object} o object
* @param {object} o object
* @param {string} o.highlightThis highlightThis is a string that contains words that should be highlighted
* @param {string} o.string is the text that should be highlighted
* @param {string} o.highlight is a optional string describing how the value should be higlighted with.
                Default == <b>$1</b>, where $1 is the match (must be in the string).
* @returns {undefined|string} undefined if the searchText is undefined otherwise the given string with the given words highlighted.
* @example  var highlighted = highlightText({
*           highlightThis: 'aj',
*           string: 'Ajabaja',
*           highlight: '<span class="spanHighlight">$1</span>'});
*           --> highlighted = "<span class="spanHighlight">Aj</span>ab<span class="spanHighlight">aj</span>a"
*/
export function highlightText(o) {
    o.highlightThis = typeof o.highlightThis === 'undefined' ? '' : o.highlightThis;
    o.string = typeof o.string === 'undefined' ? '' : o.string;
    o.highlight = typeof o.highlight === 'undefined' ? '<b>$1</b>' : o.highlight;

    if (o.string === undefined) {
        return undefined;
    }

    // split the string to words
    var arrayHighlightWords = o.highlightThis.match(/\S+/g);

    // remove all words that is b or B
    var aBWasRemoved = false;
    var searchTerm = 'b';
    for (var i = arrayHighlightWords.length - 1; i >= 0; i--) {
        if (arrayHighlightWords[i].toLowerCase() === searchTerm) {
            arrayHighlightWords.splice(i, 1);
            aBWasRemoved = true;
            // break;       //<-- Uncomment  if only the first term has to be removed
        }
    }

    // highlight with b first
    if (aBWasRemoved) {
        o.string = highlight({ highlightThis: 'b', string: o.string, highlight: '<b>$1</b>' });
    }

    for (var i2 = 0; i2 < arrayHighlightWords.length; i2++) {
        var highlightWord = arrayHighlightWords[i2];
        o.string = highlight({ highlightThis: highlightWord, string: o.string, highlight: o.highlight });
    }
    return o.string;
}

/**
* OBS! If you only want to highlight text, use window.unify.highlightText
* preg_quote rewrites given string so it will be possible to insert as a part of a regular expression (similar to PHP’s preg_quote) 
* @function 
* @param {string} str the string that should be rewritten
* @param {string} delimiter the string that will be put around the string (may be broken..)
* @returns {string} string with all special chars with a pre \
*/
export function preg_quote(str, delimiter) { // eslint-disable-line camelcase
    //  discuss at: http://locutus.io/php/preg_quote/
    // original by: booeyOH
    // improved by: Ates Goral (http://magnetiq.com)
    // improved by: Kevin van Zonneveld (http://kvz.io)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
    //   example 1: preg_quote("$40")
    //   returns 1: '\\$40'
    //   example 2: preg_quote("*RRRING* Hello?")
    //   returns 2: '\\*RRRING\\* Hello\\?'
    //   example 3: preg_quote("\\.+*?[^]$(){}=!<>|:")
    //   returns 3: '\\\\\\.\\+\\*\\?\\[\\^\\]\\$\\(\\)\\{\\}\\=\\!\\<\\>\\|\\:'

    return (str + '')
        .replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
}

/**
 * Gets the closest parent element with a transform other than 'none'.
 * If no transformed parent exists; return undefined.
 * @param {object} element : HTMLElement
 * @returns {object|undefined} an object or undefined if non was found
 */
export function getClosestTransformedElement(element) {
    var $element = $(element);
    if (!$element || !$element.length || !$element[0] || $element.is('body') || $element.is('html')) {
        return undefined;
    }
    if (($element.css('transform') && $element.css('transform').length > 0 && $element.css('transform') !== 'none') ||
        ($element.css('webkitTransform') && $element.css('webkitTransform').length > 0 && $element.css('webkitTransform') !== 'none')) {
        return $element[0];
    }

    return getClosestTransformedElement($element.parent()[0]);

}

/**
* Executes the callback function with the arguments `canScrollRight`and `canScrollLeft` so the user can
* respond to changes of the possibility to scroll in a given direction. (Currently only supports the X axis).
*
* Read before use: This method executes the callback on window resize and on ftscroller scroll. 
* Therefore the callback should only perform a minimal amount of work (like adding a class).
* @param {object} ftscroller ftscroller object?
* @param {object} callback callback function
*/
export function onFTScrollerScrollabilityChange(ftscroller, callback) {
    if (disabledTriggers === undefined) {
        var disabledTriggers = {};
    }

    var endX = Number.MAX_VALUE;

    /* Math.ceil is used because scrollWidth seems to be rounded */
    var isScrollable = Math.ceil($(ftscroller.contentContainerNode).parent().innerWidth()) < ftscroller.scrollWidth;

    var canScrollRight = isScrollable;
    var canScrollLeft = false;

    if (isScrollable) {
        callback(true, canScrollLeft);
    }

    /* This ensures the scroller is updated even if data are added dynamically slightly later */
    window.setTimeout(function () {
        ftscroller.updateDimensions();

        endX = Number.MAX_VALUE;

        isScrollable = Math.ceil($(ftscroller.contentContainerNode).parent().innerWidth()) < ftscroller.scrollWidth;

        if (isScrollable) {
            callback(canScrollRight, canScrollLeft);
        }
    }, 500);

    if (!disabledTriggers['resize']) {
        $(window).on('resize', function () {
            endX = Number.MAX_VALUE;

            isScrollable = Math.ceil($(ftscroller.contentContainerNode).parent().innerWidth()) < ftscroller.scrollWidth;
            if (isScrollable) {
                canScrollRight = true;
            } else {
                canScrollRight = false;
            }

            callback(canScrollRight, canScrollLeft);
        });
    }

    if (!disabledTriggers['scroll']) {
        ftscroller.addEventListener('scroll', function (event) {

            canScrollRight = !(event.scrollLeft >= endX);
            canScrollLeft = !(event.scrollLeft <= 0);

            callback(canScrollRight, canScrollLeft);
        });
    }

    /* This seems to be the only way to tell when it's not possible to scroll to the right anymore */
    ftscroller.addEventListener('reachedend', function (event) {
        /* Timeout was used to get around a bug where scrollLeft wasn't set until some time after reachedend had occured */
        window.setTimeout(function () {
            endX = event.srcObject.scrollLeft - 1;
            callback(false, canScrollLeft);
        }, 100);
    });
}

/**
 * Inlines all external SVGs that has the unify-svg class.
 *
 * Source: https://stackoverflow.com/a/11978996 , 2017-06-19
 */
export function inlineExternalSVGs() {
    window.jQuery('img.unify-svg').each(function () {
        var $img = window.jQuery(this);
        var imgId = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgUrl = $img.attr('src');

        window.jQuery.get(imgUrl, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = window.jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgId !== 'undefined') {
                $svg = $svg.attr('id', imgId);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' ' + $svg.attr('class'));
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });
}

/* https://davidwalsh.name/javascript-debounce-function
* Returns a function, that, as long as it continues to be invoked, will not
* be triggered. The function will be called after it stops being called for
* N milliseconds. If `immediate` is passed, trigger the function on the
* leading edge, instead of the trailing.
*/
export function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export function checksum(s) {
    var hash = 0, strlen = s.length, i, c;
    if (strlen === 0) {
        return hash;
    }
    for (i = 0; i < strlen; i++) {
        c = s.charCodeAt(i);
        hash = ((hash << 5) - hash) + c;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};

